import { useEventHubContext } from 'src/contexts/EventHubContext';
import { Event, Listing } from 'src/WebApiController';

import { InventoryEventDetail } from './InventoryEventDetail/InventoryEventDetail';
import * as styles from './InventoryEventPageRightPanel.css';
import { InventoryEventTabs } from './InventoryEventTabs';
import { StubHubListingsWithManualPricing } from './MarketListings/StubHubListingsWithManualPricing';

type InventoryEventPageRightPanelProps = {
  event: Event;
  listings: Listing[] | null | undefined;
  selectedListingIds: number[];
  activeTab: InventoryEventTabs;
};

export const InventoryEventPageRightPanel = (
  props: InventoryEventPageRightPanelProps
) => {
  const { isOnSidePanel } = useEventHubContext();

  if (isOnSidePanel) {
    return (
      <div className={styles.companionModeSidePanelContainer}>
        <InventoryEventPageRightPanelWrapper {...props} />
      </div>
    );
  }

  return <InventoryEventPageRightPanelWrapper {...props} />;
};

const InventoryEventPageRightPanelWrapper = ({
  activeTab,
  listings,
  selectedListingIds,
  event,
}: InventoryEventPageRightPanelProps) => {
  if (activeTab === InventoryEventTabs.ManualPricing) {
    return (
      <StubHubListingsWithManualPricing
        event={event}
        eventListings={listings}
        selectedListingIds={selectedListingIds}
      />
    );
  }

  return (
    <InventoryEventDetail
      event={event}
      eventListings={listings}
      selectedListingIds={selectedListingIds}
    />
  );
};
